import Vue from 'vue'
import Vuex from 'vuex'
import {functions, FieldValue, ColeccionLanding} from '@/FirebaseConfig'
Vue.use(Vuex)
export default {
    namespaced:true,
    state:{
      contacto: {
        nombre: '',
        correo_electrónico: '',
        mensaje: '',
        telefono: '',
        ciudad: '',
      },
      mensaje: {
        título: '',
        cuerpo: '',
      },
      correo_para_suscripción: '',
    },
    actions: {
      enviar_correo:  ({state, rootState, commit})=>{
        return new Promise(async(resolve, rejected)=>{
          try {
            commit('Ayudas/cargando', true, {root: true})
            const _enviar_correo = functions.httpsCallable('correo_electronico-enviar_correo_electronico') 
            const configuracion_de_correo = rootState.CMS.contenido.configuracion_de_correo
            const título = 'Se ha contactado con usted: '
            const texto = `Contacto: ${state.contacto.nombre}, Teléfono: ${state.contacto.telefono}, Ciudad: ${state.contacto.ciudad} `
            const asunto = 'Nueva solicitud de contacto' 
            await _enviar_correo({
              titulo: título,
              correo_electronico: state.contacto.correo_electrónico,
              cuerpo: texto,
              asunto,
              configuracion_de_correo
            })
            commit('Ayudas/cargando', false, {root: true})
            resolve()
          } catch (error) {
            rejected(error)
          }
        })
      },
      suscribirse: async ({state, commit})=>{
        commit('Ayudas/cargando', true, {root: true})
        ColeccionLanding.update({correos: FieldValue.arrayUnion({correo: state.correo_para_suscripción, suscrito_el: new Date})})
        commit('limpiar_correo_para_suscripción')
        commit('Ayudas/launchSnackbar', '¡Gracias por suscribirse!', {root: true})
        commit('Ayudas/cargando', false, {root: true})
      },
    },
    mutations: {
      limpiar_contacto: (state)=>{
        state.contacto =  {
          nombre: '',
          correo_electrónico: '',
          mensaje: '',
          telefono: '',
          ciudad: '',
        }
      },
      limpiar_correo_para_suscripción: (state)=>{
        state.correo_para_suscripción = ''
      },
      limpiar_mensaje: (state)=>{
        state.mensaje = {
          título: '',
          cuerpo: '',
        }
      },
    },
}
